<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("genre", 1) }}</div>
        <div class="section-subTitle my-2">{{ $t("genre_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="isEditable && $can('update', 'Genre')"
          variant="default"
          class="btn-blue"
          @click="() => updateOrder()"
          >{{ $t("Save") }}</b-button
        >
        <b-button
          v-else-if="$can('update', 'Genre')"
          variant="default"
          class="btn-blue"
          @click="() => editOrder()"
          >{{ $t("Edit order") }}</b-button
        >
        <b-button
          v-if="$can('create', 'Genre')"
          variant="default"
          to="add-genre"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          @input="onSearch"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <div class="mx-2">
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <!-- GRID VIEW -->
    <!-- <div class="desg-grid-container" v-if="gridView">
      <div
        class="col-md-4 col-lg-4 col-xl-3 px-0"
        v-if="Genre.length > 0"
        v-for="(item, key) in Genre"
        :key="key"
      >
        <div class="desg-box">
          <div class="d-flex justify-content-between">
            <h6>{{ $tc(item.g_name, 1) }}</h6>
            <div>
              <b-dropdown right variant="edit">
                <b-dropdown-item
                  v-if="$can('update', 'Genre')"
                  @click="goToRoute('/master/edit-genre', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item @click="goToRoute('/master/view-genre', item)">
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>

          <div class="d-flex justify-content-between align-items-end">
            <div class="d-flex align-items-end lh-1"></div>
            <div class="d-flex align-items-end">
              <StatusDot :status="item.g_is_active ? 'active' : 'inactive'" />
            </div>
          </div>
        </div>
      </div>
      <div v-if="Genre.length == 0">
        <p>{{ $t("NoRecords") }}</p>
      </div>
    </div> -->

    <!-- <CustomTable
      :rows="table_columns"
      :data="Genre"
      :show_status_column="true"
      status_prop_name="g_is_active"
      :status_prop_true_value="true"
      :show_edit="$can('update', 'Genre') ? true : false"
      :show_view="true"
      edit_path="/master/edit-genre"
      edit_primary_id="g_id"
      view_path="/master/view-genre"
      view_primary_id="g_id"
      :onSort="onSortValue"
      :use_dots="false"
      :disableSearch="true"
      :disableChangePerPage="true"
      :disablePagination="true"
    /> -->

    <table class="list-view-table">
      <thead>
        <tr>
          <th class="text-left">
            <span class="pr-5">{{ $tc("active") }}</span>
          </th>
          <th v-for="(row, rowIndex) in table_columns" :key="rowIndex">
            <img
              v-if="columnName != row.prop_name && row.enable_sort"
              @click="onSortValue(row.prop_name, 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending && row.enable_sort"
              @click="onSortValue(row.prop_name, 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && !isAscending && row.enable_sort"
              @click="onSortValue(row.prop_name, 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <span class="pr-5">{{ row.name }}</span>
          </th>
        </tr>
      </thead>
        <template v-if="Genre && Genre.length > 0">
        <draggable :list="Genre" tag="tbody" v-bind="dragOptions" @end="endSort($event); drag= flase;" @start = "drag = true">
        <tr v-for="(item, key) in Genre" :key="key">
          <td>
            <div class="d-flex align-items-center justify-content-start">
              <!-- <StatusDot
                :status="
                  item.g_is_active === true
                    ? 'active'
                    : 'inactive'
                "
              /> -->
              <!-- <label class="ios-switch" v-else> -->
              <b-form-checkbox
                :checked="item.g_is_active === true"
                type="checkbox"
                class="j-checkbox"
                disabled
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
              <div
              v-if="$can('update', 'Genre')"
                class="ml-4 clickable-icon"
                @click="goToRoute('/master/edit-genre', item, 'edit')"
                style="cursor: pointer"
                v-b-tooltip="'Edit'"
                tabindex="0"
              >
                <i class="edit-pen icon blue-icon"></i>
              </div>
              <div
                class="ml-2 clickable-icon"
                @click="goToRoute('/master/view-genre', item, 'view')"
                style="cursor: pointer"
                v-b-tooltip="'View'"
                tabindex="0"
              >
                <i class="icon-eye icon blue-icon"></i>
              </div>
            </div>
          </td>
          <td>{{ item.g_name }}</td>
          <td>{{ item.genre_abbr }}</td>
          <td :class="{ 'text-success': item.visible_on_website, 'text-danger': !item.visible_on_website }"
          >{{ item.visible_on_website === true ? 'Y' : 'N' }}</td>
          <td>{{ item.g_order }}</td>
        </tr>
    </draggable>
  </template>
      <tbody v-if="Genre.length == 0">
        <tr>
          <td :colspan="rows.length + 1">
            <!-- <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div> -->
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="Genre.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Genre from "@/helper/formJSONMaster/Genre";
import CustomTable from "@/components/Partials/CustomTable.vue";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import draggable from "vuedraggable";
export default {
  components: {
    CustomTable,
    StatusDot,
    FilterByStatusDropdown,
    draggable,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      //for search
      debounce: null,
      searchValue: "",
      searchKey: "g_name", //the key name in your table

      gridView: false,
      listView: true,
      Methods: Genre.Methods,
      Genre: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",
      table_columns: [
        {
          prop_name: "g_name",
          name: this.$tc("genre", 1),
          enable_sort: true,
        },
        {
          prop_name: "genre_abbr",
          name: "Genre Short Name",
        },
        {
          prop_name: "visible_on_website",
          name: "Visible On Website",
        },
        {
          prop_name: "g_order",
          name: "Genre Order",
        },
      ],
      drag: false,
      isEditable: false,
    };
  },
  beforeMount() {
    this.getGenreList();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    draggableElements: function () {
      return this.isEditable;
    },
    endSort(event) {
      this.Genre.map((x, index) => {
        if (this.currentPage != 1) {
          x.g_order = this.perPage * (this.currentPage - 1) + (index + 1);
        } else {
          x.g_order = index + 1;
        }
      });
      // console.log("this.sorted Labels", this.Labels);
      // console.log("this.event", event);
    },
    editOrder: function () {
      this.isEditable = true;
      if (this.isEditable) {
        this.onDropDownChangeValue("All");
        this.$forceUpdate();
      }
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        // console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        // console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getGenreList();
      } else {
        this.currentPage = event;
        this.getGenreList();
      }
    },

    //search
    onSearch(event) {
      this.searchValue = "";
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.searchValue = event;
        this.getGenreList();
      }, 1500);
    },

    goToRoute: function (path, item) {
      // console.log("item :", item);
      const { g_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: g_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getGenreList();
    },
    
    getGenreList: function () {
      this.Genre = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      // body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&searchKey=${this.searchKey}&searchValue=${this.searchValue}&orderBy=${this.orderby}&columnName=${this.columnName}`;
      body.url += `?limit=${this.perPage}&currentPage=${this.currentPage}&searchKey=${this.searchKey}&searchValue=${this.searchValue}&orderBy=${this.orderby}&columnName=g_order`;
      // console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.Genre = data.Records;
              // console.log('this.Genre:', this.Genre)
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    updateOrder: function () {
      this.isEditable = false;
      let payload = {
        ms_genre: this.Genre,
      };
      MasterService.updateGenreOrder(payload)
        .then((data) => {
          if (data && data.status) {
            this.onDropDownChangeValue("10");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/GenreComponents/genre.vue